module.exports = __webpack_public_path__ + "img/album-backgrounds-2021-11-01.c5e5477.png";